import React from 'react';

import { Button } from 'Permafrost/components/ui-foundations/buttons/Button/Button';
import { FilterOption } from '../../FilterSelect';
import { StyledFilterSelectControls } from './FilterSelectControls.styles';

type Props = {
  currentStoreFilters: FilterOption[];
  selectedFilters: FilterOption[];
  onSave: (selectedFilters: FilterOption[]) => void;
  setIsOpen: (open: boolean) => void;
  setSelectedFilters: (selectedFilters: FilterOption[]) => void;
};

export const FilterSelectControls = ({
  currentStoreFilters,
  selectedFilters,
  onSave,
  setIsOpen,
  setSelectedFilters,
}: Props) => {
  return (
    <StyledFilterSelectControls>
      <Button
        aria-label="Apply filter button"
        className="apply-btn"
        onClick={() => {
          onSave(selectedFilters);
          setIsOpen(false);
        }}
      >
        Apply
      </Button>
      <Button
        aria-label="Cancel filter button"
        className="cancel-btn"
        onClick={() => {
          setSelectedFilters(currentStoreFilters);
          setIsOpen(false);
        }}
      >
        Cancel
      </Button>
    </StyledFilterSelectControls>
  );
};
